import React, { Component } from 'react';
class Footer extends Component {
    render() {
        
        return (
            <div>
                <div className="footer">
                    <p>Copyright Oxygen Global 2025. All Right Reserved</p>
                </div>
            </div>
        );
    }
}

export default Footer;


// WEBPACK FOOTER //
// ./src/components/footer/footer.jsx